import { StandardEvents } from '@shopify/events';

/**
 * Buy-more-save-more milestone bar in the cart drawer. The server renders it with the current item count; this
 * keeps it in step afterwards by re-reading the cart whenever Horizon reports a cart change or the drawer opens.
 */
const MESSAGES = {
  1: '<strong>25% off unlocked</strong> · Add <strong>1</strong> more for 30% off',
  2: '<strong>30% off unlocked</strong> · Add <strong>1</strong> more for 35% off + ₹1,000 gift card',
  top: '<strong>Best offer unlocked</strong> · 35% off + ₹1,000 gift card',
};

class CartOfferProgress extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    const { signal } = this.#abort;
    const refresh = () => this.refresh();
    document.addEventListener(StandardEvents.cartLinesUpdate, refresh, { signal });
    document.addEventListener('cart:update', refresh, { signal });
    document.addEventListener('theme-drawer:open', refresh, { signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  async refresh() {
    try {
      const root = window.Shopify?.routes?.root ?? '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      this.render(cart.item_count);
    } catch {
      // Keep what is shown; the drawer's own refresh brings the server-rendered state.
    }
  }

  /** @param {number} count */
  render(count) {
    if (String(count) === this.dataset.count) return;
    this.dataset.count = String(count);
    this.hidden = count < 1;
    this.classList.toggle('cart-offer--complete', count >= 3);
    if (count < 1) return;

    const message = this.querySelector('.cart-offer__message');
    if (message) message.innerHTML = MESSAGES[count] ?? MESSAGES.top;

    this.querySelectorAll('.cart-offer__step').forEach((step) => {
      const index = Number(step.getAttribute('data-step'));
      step.classList.toggle('is-done', count >= index);
      step.classList.toggle('is-next', index === count + 1);
    });
  }
}

if (!customElements.get('cart-offer-progress')) customElements.define('cart-offer-progress', CartOfferProgress);
